import { Box, Typography, Grid } from '@mui/material';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import { NetworkCard } from './NetworkCard';
import type { Equipment } from '../../context/EquipmentContext';

interface NetworkSettingsProps {
  equipment: Equipment;
}

export function NetworkSettings({ equipment }: NetworkSettingsProps) {
  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <NetworkCheckIcon sx={{ color: '#3B4EFF', fontSize: 22 }} />
        <Typography fontWeight={700} fontSize={17} color="#23272E">Configurações de Rede</Typography>
      </Box>
      <Grid container spacing={2}>
        <NetworkCard
          icon={<DeviceHubIcon sx={{ color: '#22C55E', fontSize: 20 }} />}
          label="Contador"
          value={equipment.counter}
          color="#22C55E"
          bgColor="#E6F9ED"
          borderColor="#A7F3D0"
        />
        <NetworkCard
          icon={<NetworkCheckIcon sx={{ color: '#3B82F6', fontSize: 20 }} />}
          label="Receptores"
          value={equipment.receptors}
          color="#3B82F6"
          bgColor="#E6F4FF"
          borderColor="#BAE6FD"
        />
        <NetworkCard
          icon={<SettingsEthernetIcon sx={{ color: '#F59E42', fontSize: 20 }} />}
          label="Hosts"
          value={equipment.hosts}
          color="#F59E42"
          bgColor="#FFF7ED"
          borderColor="#FDE68A"
        />
        <NetworkCard
          icon={<SettingsEthernetIcon sx={{ color: '#22C55E', fontSize: 20 }} />}
          label="Portas"
          value={equipment.portQuantity}
          color="#22C55E"
          bgColor="#E6F9ED"
          borderColor="#A7F3D0"
        />
        <Grid item xs={12}>
          <NetworkCard
            icon={<SettingsEthernetIcon sx={{ color: '#EF4444', fontSize: 20 }} />}
            label="Portas Finais"
            value={equipment.finalPortQuantity}
            color="#EF4444"
            bgColor="#FEE2E2"
            borderColor="#FCA5A5"
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
} 